
import {
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap"

import React, { useEffect } from "react"
import FIELDS from "./CONSTANT"
import { FieldInput } from "../../../components/FieldInput"




export default function DeductionForm({validation}){

    return(
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <Row>
                            {FIELDS.map(f => (
                                <FieldInput key={f.key} f={f} validation={validation} />
                            ))}
                        
                        </Row>
                    </CardBody>
                </Card>
            </Col>
          
        </Row>
    )
}